import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createBlock(_component_svg_icon, {
    width: _ctx.width,
    height: _ctx.height,
    iconColor: _ctx.iconColor
  }, {
    default: _withCtx(() => _cache[0] || (_cache[0] = [
      _createElementVNode("line", {
        id: "line1",
        x1: "12",
        y1: "2",
        x2: "12",
        y2: "6"
      }, null, -1),
      _createElementVNode("line", {
        id: "line2",
        x1: "16.24",
        y1: "7.76",
        x2: "19.07",
        y2: "4.93"
      }, null, -1),
      _createElementVNode("line", {
        id: "line3",
        x1: "18",
        y1: "12",
        x2: "22",
        y2: "12"
      }, null, -1),
      _createElementVNode("line", {
        id: "line4",
        x1: "16.24",
        y1: "16.24",
        x2: "19.07",
        y2: "19.07"
      }, null, -1),
      _createElementVNode("line", {
        id: "line5",
        x1: "12",
        y1: "18",
        x2: "12",
        y2: "22"
      }, null, -1),
      _createElementVNode("line", {
        id: "line6",
        x1: "4.93",
        y1: "19.07",
        x2: "7.76",
        y2: "16.24"
      }, null, -1),
      _createElementVNode("line", {
        id: "line7",
        x1: "2",
        y1: "12",
        x2: "6",
        y2: "12"
      }, null, -1),
      _createElementVNode("line", {
        id: "line8",
        x1: "4.93",
        y1: "4.93",
        x2: "7.76",
        y2: "7.76"
      }, null, -1)
    ])),
    _: 1,
    __: [0]
  }, 8, ["width", "height", "iconColor"]))
}